import { css } from "@compiled/react";
import { useIntl } from "react-intl";

import PaidHero from "@/patterns/paid-hero";

const heroStyles = css({
    "backgroundColor": "#DEEBFF",
    "backgroundImage": `var(--hero-bg-1, linear-gradient(transparent, transparent)), linear-gradient(287.15deg, #FAFBFC 0%, #DEEBFF 8.06%, #B3D4FF 35.45%, #DEEBFF 77.6%, #FAFBFC 100%)`,
    "backgroundPosition": "top right, 0 0",
    "backgroundRepeat": "no-repeat",
    "backgroundSize": "auto 100% , auto",

    "@media only screen and (min-width: 1024px)": {
        "--hero-bg-1": `url("https://wac-cdn.atlassian.com/dam/jcr:f96e5a0a-7af5-4cc6-884c-b51416e65e41/JSM_BG%20Graphics.png?cdnVersion=1276")`
    }
});

const HeroSectionPaidLpJswTracker = () => {
    const intl = useIntl();
    return (
        <div css={heroStyles}>
            <PaidHero
                headerText={intl.formatMessage({
                    id: "JiraSoftwarePage.paidLpJswTracker.heroHeader",
                    defaultMessage: "Bug tracking done right with Jira Software"
                })}
                secondaryText={intl.formatMessage({
                    id: "JiraSoftwarePage.paidLpJswTracker.heroBody",
                    defaultMessage: "Report, track, and prioritize bugs"
                })}
                featuresLabel={intl.formatMessage({
                    id: "JiraSoftwarePage.paidLpJswTracker.heroListHeading",
                    defaultMessage: "INCLUDED IN YOUR FREE PLAN:"
                })}
                featuresList={[
                    intl.formatMessage({
                        id: "JiraSoftwarePage.paidLpJswTracker.heroListItem1",
                        defaultMessage: "10 user licenses"
                    }),
                    intl.formatMessage({
                        id: "JiraSoftwarePage.paidLpJswTracker.heroListItem2",
                        defaultMessage: "Workflows and automation"
                    }),
                    intl.formatMessage({
                        id: "JiraSoftwarePage.paidLpJswTracker.heroListItem3",
                        defaultMessage: "Scale agile practices"
                    }),
                    intl.formatMessage({
                        id: "JiraSoftwarePage.paidLpJswTracker.heroListItem4",
                        defaultMessage: "Consolidate workflows"
                    }),
                    intl.formatMessage({
                        id: "JiraSoftwarePage.paidLpJswTracker.heroListItem5",
                        defaultMessage:
                            "Integrations with thousands of other tools"
                    })
                ]}
            />
        </div>
    );
};

export default HeroSectionPaidLpJswTracker;
